import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M4.365 1.27c-1.273 0-2.367 1.058-2.367 2.3a.5.5 0 1 1-1 0c0-1.824 1.573-3.3 3.367-3.3 1.81 0 3.3 1.49 3.3 3.3a.5.5 0 1 1-1 0c0-1.257-1.043-2.3-2.3-2.3M5.031 6.904c0-.718.616-1.334 1.334-1.334.717 0 1.333.616 1.333 1.334v1.2a.333.333 0 0 1-.667 0v-1.2a.693.693 0 0 0-.666-.667.693.693 0 0 0-.667.667.333.333 0 1 1-.667 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M8.365 6.904a.693.693 0 0 0-.667.666.333.333 0 1 1-.667 0c0-.717.616-1.333 1.334-1.333.717 0 1.333.616 1.333 1.333v1.2a.333.333 0 1 1-.667 0v-1.2a.693.693 0 0 0-.666-.666",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "m4.323 2.24.042-.003c.717 0 1.333.616 1.333 1.333v4.534a.333.333 0 1 1-.667 0V3.57a.694.694 0 0 0-.646-.666c-.408.06-.687.355-.687.666v5.867a.333.333 0 0 1-.57.236L1.863 8.406a.713.713 0 0 0-.995 0 .676.676 0 0 0-.092.846l.001.001 2.335 3.536a3.64 3.64 0 0 0 3.054 1.648h1.2a3.68 3.68 0 0 0 3.666-3.667V8.237a.693.693 0 0 0-.666-.667.693.693 0 0 0-.667.667.333.333 0 0 1-.667 0c0-.717.616-1.333 1.334-1.333.717 0 1.333.616 1.333 1.333v2.533a4.345 4.345 0 0 1-4.333 4.334h-1.2a4.3 4.3 0 0 1-3.613-1.951L.221 9.622a1.34 1.34 0 0 1 .175-1.687 1.38 1.38 0 0 1 1.938 0l.697.697V3.57c0-.75.645-1.25 1.292-1.33",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }